import type { SeasonPhase } from "./queries/memberships";

// Canonical Czech labels for the derived registration phase. Shared by
// the seasons admin table and the dashboard season card so the wording
// never diverges (see the terminology table in AGENTS.md).
export const SEASON_PHASE_LABELS: Record<SeasonPhase, string> = {
  pre_registration: "Před registrací",
  registration_open: "Registrace otevřena",
  registration_closed: "Registrace uzavřena",
};

type BadgeVariant = "ok" | "warn" | "err" | "info" | "muted";

export const SEASON_PHASE_VARIANT: Record<SeasonPhase, BadgeVariant> = {
  pre_registration: "muted",
  registration_open: "ok",
  registration_closed: "warn",
};

/**
 * Which season came first, as a number — or null when the code cannot
 * say.
 *
 * A season code is free text and the federation writes it more than one
 * way („2026", „2026/2027"), so the years in it are what orders them.
 * The LATER year is taken: of „2026/2027" it is 2027 that competitions
 * run in, and a season labelled „2026/2027" therefore follows „2026".
 *
 * Null rather than a fallback, and that is the whole contract: a code
 * with no year in it cannot be placed, and a caller that guessed would
 * be deciding whether a season is CLOSED on the strength of a naming
 * convention. Substituting the current year did exactly that — with an
 * active season named „Testovací" the frontend hid „Nová soutěž" for a
 * season the server would have accepted.
 *
 * Twin of `season.Ordinal` in internal/service/season/phase.go, which
 * returns the same "I cannot say" as a second value.
 */
export function seasonOrdinal(seasonCode: string): number | null {
  const years = seasonCode.match(/\d{4}/g);
  return years ? Number(years[years.length - 1]) : null;
}
